import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { ComponentPropertyType } from '../models/ComponentPropertyType'
import { ComponentPropertyTypeForm } from '../forms/ComponentPropertyTypeForm'
import { ComponentPropertyTypeFilter } from '../filters/ComponentPropertyTypeFilter'
import { ComponentPropertyTypeService } from '../services/ComponentPropertyTypeService'

export const useComponentPropertyTypeStore: KsStoreHook<ComponentPropertyType, ComponentPropertyTypeForm, ComponentPropertyTypeFilter> = createKsStore({
  id: 'componentPropertyTypes',
  modelClass: ComponentPropertyType,
  formClass: ComponentPropertyTypeForm,
  filterClass: ComponentPropertyTypeFilter,
  service: ComponentPropertyTypeService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `PropertyType #${item.id}`,
  signalREventName: 'ComponentPropertyTypeModel',
  isReferential: true
})
